import moment from 'moment'
import { type QuestionnaireSessionApiOutContract } from 'api/generated/pwrdbyQuickMDProvidersApi.schemas'

type Props = {
  session?: QuestionnaireSessionApiOutContract | undefined
}

// Renders an online/async visit's questionnaire answers (flat Question/Answer pairs), reusing the
// intake-questions page styling. Used instead of the intake-form Questions view when a sessionId
// is present in the URL.
export const QuestionnaireAnswers = ({ session }: Props) => {
  if (!session) return null

  const completedOn = session.CompleteDateTime ? moment(session.CompleteDateTime).format('MMM DD YYYY') : '--'

  return (
    <div className='intake-questions-table'>
      <div className='intake-questions-item-container'>
        <div className='intake-questions-question'>Completed on: {completedOn}</div>
      </div>
      <hr className='intake-questions-divider' />
      {(session.Answers ?? []).map((answer) => (
        <div className='intake-questions-item-container' key={answer.Question}>
          <div className='intake-questions-question'>{answer.Question}</div>
          <div className='intake-questions-answer'>{answer.Answer}</div>
        </div>
      ))}
    </div>
  )
}
